import React from 'react';
import { Navigate } from 'react-router-dom';
import WindxWrapper from 'components/RouteWrappers/Windx';
import Windx from 'views/Windx';
import SemiHorario from 'views/Windx/SemiHorario';
import SemiHorarioLayout from 'views/Windx/SemiHorario/Layout';
import SemanalLayout from 'views/Windx/Semanal/Layout';
import Semanal from 'views/Windx/Semanal';
import Comparativo from 'views/Windx/Comparativo';
import Personalized from 'views/Windx/Personalized';
import About from 'views/Windx/About';

/**
 * Roteamento do modulo Windx (FE-WINDX-001 + FE-WINDX-018 + FE-WINDX-047 + FE-WINDX-050).
 *
 * Estrutura (espelho do Flux):
 *   /windx                                       -> Home com ProductCardList
 *   /windx/automatic                             -> WindxWrapper (tabs + ControlPanel)
 *     ├─ ''                                      -> redirect para 'semi-horario'
 *     ├─ 'semi-horario'/'diario' (FE-WINDX-050)  -> SemiHorarioLayout
 *     │   ├─ 'semi-horario'                      -> SemiHorario (granularidade='semi')
 *     │   └─ 'diario'                            -> SemiHorario (granularidade='diario')
 *     ├─ 'semanal'                               -> SemanalLayout
 *     │   ├─ ''                                  -> Semanal
 *     │   └─ 'comparativo'                       -> Comparativo
 *   /windx/personalized                          -> placeholder
 *   /windx/about                                 -> Sobre Windx (Tabs + PDF)
 *
 * O `WindxWrapper` (titulo WINDX + tabs WEOL-SH/WEOL-SM + Painel de
 * Controle) vive APENAS sob `/windx/automatic/*`. As demais rotas (home,
 * personalized, about) renderizam sem o wrapper — elas tem seu proprio
 * layout autonomo.
 *
 * Redirects backward-compat:
 *   /windx/automatic                             -> /windx/automatic/semi-horario
 *   /windx/semanal                               -> /windx/automatic/semanal
 *   /windx/semanal/comparativo                   -> /windx/automatic/semanal/comparativo
 *   /windx/comparativo                           -> /windx/automatic/semanal/comparativo
 */
const windxRouter = {
  path: 'windx',
  children: [
    { path: '', element: <Windx /> },
    {
      path: 'automatic',
      element: <WindxWrapper />,
      children: [
        // FE-WINDX-050: index redireciona para semi-horario (default sub-tab).
        { index: true, element: <Navigate to="semi-horario" replace /> },
        {
          element: <SemiHorarioLayout />,
          children: [
            { path: 'semi-horario', element: <SemiHorario /> },
            // Mesmo componente — granularidade vem do Redux.
            { path: 'diario', element: <SemiHorario /> },
          ],
        },
        {
          path: 'semanal',
          element: <SemanalLayout />,
          children: [
            { path: '', element: <Semanal /> },
            { path: 'comparativo', element: <Comparativo /> },
          ],
        },
      ],
    },
    { path: 'personalized', element: <Personalized /> },
    { path: 'about', element: <About /> },

    // Redirects backward-compat — bookmarks antigos
    { path: 'semanal', element: <Navigate to="/windx/automatic/semanal" replace /> },
    { path: 'semanal/comparativo', element: <Navigate to="/windx/automatic/semanal/comparativo" replace /> },
    { path: 'comparativo', element: <Navigate to="/windx/automatic/semanal/comparativo" replace /> },
  ],
};

export default windxRouter;
